import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var LinkIcon = function LinkIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "LinkIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M10.987 2.65a2 2 0 0 0-.811.122 1.8 1.8 0 0 0-.65.416l-.944.944a.824.824 0 1 1-1.164-1.165l.944-.944c.35-.35.771-.62 1.237-.794s.964-.249 1.466-.225.998.146 1.461.356a4.24 4.24 0 0 1 2.114 2.114c.21.463.332.959.356 1.46.024.503-.051 1.001-.226 1.467a3.5 3.5 0 0 1-.793 1.237l-.944.944a.823.823 0 1 1-1.165-1.164l.944-.944c.181-.181.323-.401.416-.65s.136-.524.123-.811a2.4 2.4 0 0 0-.212-.86 2.6 2.6 0 0 0-1.292-1.292 2.4 2.4 0 0 0-.86-.211M9.695 6.305a.823.823 0 0 1 0 1.165L7.47 9.695A.824.824 0 0 1 6.305 8.53l2.226-2.225a.824.824 0 0 1 1.164 0M4.132 7.418a.824.824 0 0 1 0 1.164l-.944.944c-.363.364-.566.883-.538 1.461a2.5 2.5 0 0 0 .74 1.623 2.5 2.5 0 0 0 1.623.74c.287.014.562-.03.811-.122.249-.093.469-.235.65-.416l.944-.944a.824.824 0 0 1 1.164 1.165l-.944.944c-.35.35-.771.62-1.237.793-.466.175-.964.25-1.466.226a4.14 4.14 0 0 1-2.71-1.222 4.14 4.14 0 0 1-1.22-2.709c-.049-1.015.308-1.993 1.018-2.703l.944-.944a.824.824 0 0 1 1.165 0",
      clipRule: "evenodd"
    })
  }));
};

export { LinkIcon };
